import script from "./ChatMessageFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessageFilters.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessageFilters.vue?vue&type=style&index=0&id=251c08ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251c08ce"]])

export default __exports__